import React from "react";
import styled from "styled-components";
import FlexRow from "../components/FlexRow";
import Card from "../components/Card";
import ShadowImage from "../components/ShadowImage";
import swanGardens from "../images/swan-gardens.jpg";
import dukes from "../images/dukes.jpg";
import flemingsSteakhouse from "../images/flemings-steakhouse.jpg";
// import maggianos from "../images/maggianos.jpg";
import hilton from "../images/hilton-garden-inn.jpg";
import hiltonInverness from "../images/hilton-inverness.jpg";
import yayas from "../images/yayas.jpg";

const MapContainer = styled.div`
  flex: 1;

  padding: 1rem;
`;

const WhatsHappeningPage = () => (
  <div>
    <FlexRow>
      <Card header="Ceremony" flex="1">
        <a
          className="location"
          href="http://www3.hilton.com/en/hotels/colorado/hilton-denver-inverness-DENIRHH/index.html"
          target="_blank"
        >
          Hilton Denver Inverness
        </a>
        <p>Saturday, August 18, 2018 - 10:30AM</p>
        <ShadowImage src={swanGardens} />
        <p>
          200 Inverness Drive West
          <br />
          Englewood, CO, 80112
        </p>
      </Card>
      <Card header="Reception" flex="1">
        <a
          className="location"
          href="https://www.flemingssteakhouse.com/locations/co/englewood/"
          target="_blank"
        >
          Fleming's Steakhouse
        </a>
        <p>Saturday, August 18, 2018 - 12:00PM</p>
        <ShadowImage src={flemingsSteakhouse} />
        <p>
          191 Inverness Drive West
          <br />
          Englewood, CO 80112
        </p>
      </Card>
    </FlexRow>
    <FlexRow>
      <Card header="Rehearsal Dinner" flex="1">
        <a
          className="location"
          href="https://dukescastlerock.com/"
          target="_blank"
        >
          Duke's Steakhouse
        </a>
        <p>Friday, August 17, 2018 - 6:00PM</p>
        <ShadowImage src={dukes} />
        <p>
          363 Village Square Lane
          <br />
          Castle Pines, CO 80108
        </p>
      </Card>
      {/* <Card header="Rehearsal Dinner" flex="1">
        <a
          className="location"
          href="https://locations.maggianos.com/CO/englewood/7401-south-clinton-st./"
          target="_blank"
        >
          Maggiano's Little Italy
        </a>
        <p>Friday, August 17, 2018 - 7:00PM</p>
        <ShadowImage src={maggianos} />
        <p>
          7401 South Clinton Street
          <br />
          Englewood, CO 80112
        </p>
      </Card> */}
      <Card header="Sunday Brunch" flex="1">
        <a
          className="location"
          href="http://www.yayasdenver.com/"
          target="_blank"
        >
          YaYa's Euro Bistro
        </a>
        <p>Sunday, August 19, 2018 - 10:00AM</p>
        <ShadowImage src={yayas} width="100%" />
        <p>
          8310 East Belleview Avenue
          <br />
          Greenwood Village, CO 80111
        </p>
      </Card>
    </FlexRow>
    <FlexRow>
      <Card header="Accommodations" flex="1">
        <a
          className="location"
          href="http://group.hiltongardeninn.com/fishmanleewedding"
          target="_blank"
        >
          Hilton Garden Inn - Denver South
        </a>
        <p>Special Rate: $99 per night</p>
        <ShadowImage src={hilton} />
        <p>
          9290 Meridian Boulevard
          <br />
          Englewood, CO 80112
        </p>
        <p>
          To make a reservation,{" "}
          <a
            href="http://group.hiltongardeninn.com/fishmanleewedding"
            target="_blank"
          >
            click here
          </a>{" "}
          or call (303) 824-1550 by July 18, 2018 and request the Fishman-Lee
          wedding rate.
        </p>
      </Card>
      <Card header="Accommodations" flex="1">
        <a
          className="location"
          href="http://www3.hilton.com/en/hotels/colorado/hilton-denver-inverness-DENIRHH/index.html"
          target="_blank"
        >
          Hilton Denver Inverness
        </a>
        <p>Special Rate: $149 per night</p>
        <ShadowImage src={hiltonInverness} />
        <p>
          200 Inverness Drive West
          <br />
          Englewood, CO 80112
        </p>
        <p>
          To make a reservation,{" "}
          <a href="https://bit.ly/2GCJ1hv" target="_blank">
            click here
          </a>{" "}
          or call (303) 799-5800 by July 18, 2018 and request the Fishman-Lee
          wedding rate.
        </p>
      </Card>
    </FlexRow>
    <Card header="Map of Locations" flex="1">
      <MapContainer>
        <iframe
          src="https://www.google.com/maps/d/embed?mid=1wPrlO0cUcgRooReSZIsw_KsoVSmBo7ut&hl=en"
          width="100%"
          height="650"
        />
      </MapContainer>
    </Card>
  </div>
);

export default WhatsHappeningPage;



// WEBPACK FOOTER //
// ./src/pages/whats-happening.js